import {ArenaDescriptionTextDefaultBox} from './arena-description-text.default.box';

export const ArenaDescriptionTextBox = ArenaDescriptionTextDefaultBox;